import { createContext, useContext, useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import init from "../firebase";
import axios from "axios";
const auth = init.auth;

const userAuthContext = createContext();

export function UserAuthContextProvider({ children }) {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [user, setUser] = useState({});

  function logIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function signUp(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }
  function logOut() {
    return signOut(auth);
  }
  const [token, setToken] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      // currentUser.emailVerified true/false
      // db email_verified
      
      if (!currentUser) {
        setToken(null);
        return;
      }

      try {
        const token = await currentUser.getIdToken(); // no forced refresh
        setToken(token);
      } catch (err) {
        console.error("Token error:", err);
        setToken(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const [language, setLanguage] = useState("en");

  const leadBasePriceFinder = async (sub_cat_id) => {
    if (!sub_cat_id) return;
    try {
      const res = await axios.get(
        `${base_url}/api/v1/lead-prices/sub_category/${sub_cat_id}`
      );
      return res.data.data.amount || 100;
    } catch (error) {
      console.log(`Error : ${error}`);
      return;
    }
  };

  const categoryFinder = (category_id) => {
    switch (category_id) {
      case "1VzpExxYvO14f6epMMbB":
        return "wedding insurance";
      case "KqnhUfe1vA1ZVOXHzPOO":
        return "birthday";
      case "TJ49nhNUSBwzUowlRPmA":
        return "transportation";
      case "TwtVyXeU6ZlwN9HWtSdj":
        return "destination wedding";
      case "cpz6DDRUONI2VKYm89Hp":
        return "outfits";
      case "eQzhKP8UvvGBgfrDRFr4":
        return "corporate events";
      case "lIctLmJMzKGyp9taXkFM":
        return "vendors";
      case "trvwyuvRqNTuZQh8KNbi":
        return "venue";
      case "xhsdKgv1nh9MhAM6yQYW":
        return "event shopping";
      default:
        null;
    }
  };
  const subCategoryFinder = (sub_cat_id) => {
    switch (sub_cat_id) {
      case "52vn6kWKmCCUGk6DqKfM":
        return "lawn";
      case "8x7UFtmckFjIuWUA4oaj":
        return "hotel";
      case "Gsj5h6LfHMqWKbbWDdeh":
        return "banquet halls";
      case "WgPT5AjEU6y3lnpxxkIq":
        return "resorts";
      case "8EaQ32WZPPKQHhCb0rHa":
        return "photography";
      case "REgfHYF9tUNeip9MoIiJ":
        return "makeup";
      case "lNajYmRId9agpdMfQgBP":
        return "mehndi";
      case "KiR4d4mTOa9wO1Ug794b":
        return "wedding dj";
      case "cL3ML2kGQq73UwopisjS":
        return "decorator";
      case "UVEU5Cu4lBTzTc6U1LLC":
        return "wedding pandit";
      case "YzLGveDq8B4NGRaMynrF":
        return "anchor";
      case "JmVQxGbqLzy5vQleF7Vo":
        return "invitations";
      case "KSBiIS1ozXjskiuYSRh8":
        return "groom wear";
      case "Ro7Bc5o3VyK0c7rFVBRv":
        return "live music band";
      case "UTYv8zIn3ePt3ZkcKXow":
        return "birthday shopping";
      case "XfRVyejjN7EPxxVmGNA2":
        return "birthday venues";
      case "EOwVeI2xdMAWYyMB9Ged":
        return "brass band";
      case "ifDgK6rfWHdve2yAb8IX":
        return "bus rental";
      case "v0jnBiBS1p3Y2fTOrgLE":
        return "cake shop";
      case "YlYeYg6PFa24U3aUw5XY":
        return "car rental";
      case "kMqFV87nKkkOMDGRLYm8":
        return "magician";
      case "gnv1ceUBFqhcU1F3w6S1":
        return "florist";
      case "NJ24jdxiqTCPhKsPHpfM":
        return "gifts";
      case "fklaMSittpqblXbJ5fk4":
        return "tour packages";
      case "RBwoc5b7vB2yRl5aHDFm":
        return "clothing rentals";
      case "HT33vunkJlPeg1kiP7K2":
        return "hill places";
      case "To7Chd4Ld4UOo68GzWxq":
        return "beach places";
      case "YsD4nfH3n21oW1lS9V6I":
        return "historical place";
      case "tqnzPLgJvzZGg5AR0cQP":
        return "international wedding";
      case "R1Bi9kPxOfsqRwW9oiWk":
        return "bridal wear";
      case "zqq7qmE7wtG838LDX8hJ":
        return "catering";
      case "t5CjPhRmhZAgJ5ZxXKlQ":
        return "wedding planner";
      case "OcgLXWiDaSZxNQniDKwS":
        return "choreographer";
      case "IYURZPvwTK49OVN3eHqS":
        return "artist celebrity";
      case "Eun3JvVRoFLb4nBvq0hH":
        return "airline and helicopter";
      case "7kMNlcnAOtLsRMVtqn6R":
        return "vintage car";
      case "cLkJjfUeVHHAV3uYy7rN":
        return "government events";
      case "iAfD04pQNNJjvBLA4jeF":
        return "corporate events";
      case "FXDStEgXe9RXLiFFFMjn":
        return "safa pagdi";
      case "UyZXebMRha8pT62o7NFX":
        return "birthday decorator";
      case "y1cmw5s4CbGXZsEJCfxk":
        return "entry theme";
      case "5yNZx4882XfPis5QEe1G":
        return "sweets and fruits";
      case "7Uwq0x8t9SB2c266r4Yk":
        return "jewellery stores";
      case "hD9JlvSguojfUlxYqDAt":
        return "wedding accessories";
      default:
        null;
    }
  };
  const [currency, setCurrency] = useState({ symbol: "₹", value: 1 });

  const updateCurrency = (newCurrency) => {
    localStorage.setItem("selectedCurrency", JSON.stringify(newCurrency));
    setCurrency(newCurrency);
  };

  const generateSearchList = (businessName) => {
    const words = businessName.toLowerCase().split(" "); // Split words and convert to lowercase
    const list = [];

    // Add individual words
    list.push(...words, businessName.toLowerCase());

    // Add combinations of two words
    for (let i = 0; i < words.length - 1; i++) {
      list.push(`${words[i]} ${words[i + 1]}`);
    }

    // Add substrings of increasing length (up to full word length)
    for (const word of words) {
      for (let i = 1; i <= word.length; i++) {
        list.push(word.substring(0, i));
      }
    }

    return list;
  };

  const CityNameFinder = async (city_id) => {
    if (!city_id) return "Unknown";
    try {
      const res = await axios.get(`${base_url}/api/v1/cities/${city_id}`);
      return res.data.data.name || "Unknown";
    } catch (error) {
      console.log(`Error : ${error}`);
      return "Unknown";
    }
  };
  const convertToLSlug = (title) => {
    const lslug = title
      .toLowerCase() // Convert to lowercase
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .replace(/[^a-z0-9-]/g, "") // Remove non-alphanumeric characters and hyphens
      .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
      .replace(/^-|-$/g, ""); // Remove leading and trailing hyphens
    return lslug;
  };

  const [currentMerchant, setCurrentMerchant] = useState({});
  const [defaultCountry, setDefaultCountry] = useState(null);

  const getSingleDocumentHandler = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/users/id/${user?.uid}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCurrentMerchant(res?.data?.data);
    } catch (error) {
      console.log(`Error ${error} `);
    }
  };
  const getCurentCurrency = async () => {
    if (!currentMerchant?.country_id) return;
    try {
      const res = await axios.get(
        `${base_url}/api/v1/currency/country_id/${currentMerchant?.country_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDefaultCountry(res?.data?.data);
    } catch (error) {
      console.log(`Error ${error} `);
    }
  };
  useEffect(() => {
    if (!user?.uid) return;
    getSingleDocumentHandler();
  }, [user]);
  useEffect(() => {
    getCurentCurrency();
  }, [currentMerchant]);
  return (
    <userAuthContext.Provider
      value={{
        user,
        logIn,
        signUp,
        logOut,
        token,
        language,
        setLanguage,
        categoryFinder,
        subCategoryFinder,
        generateSearchList,
        CityNameFinder,
        convertToLSlug,
        leadBasePriceFinder,
        currency,
        updateCurrency,
        defaultCountry,
      }}
    >
      {children}
    </userAuthContext.Provider>
  );
}
export function useUserAuth() {
  return useContext(userAuthContext);
}
